var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreenLink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_143552)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.8335 11.6676C9.10506 11.9448 9.4292 12.165 9.78694 12.3153C10.1447 12.4656 10.5288 12.5431 10.9168 12.5431C11.3049 12.5431 11.689 12.4656 12.0467 12.3153C12.4045 12.165 12.7286 11.9448 13.0002 11.6676L16.3335 8.3343C16.886 7.78176 17.1964 7.03237 17.1964 6.25097C17.1964 5.46956 16.886 4.72017 16.3335 4.16763C15.781 3.6151 15.0316 3.30469 14.2502 3.30469C13.4688 3.30469 12.7194 3.6151 12.1668 4.16763L11.7502 4.5843",
    stroke: "#0E5B48",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1667 8.33246C11.8951 8.05529 11.5709 7.8351 11.2132 7.68478C10.8555 7.53446 10.4714 7.45703 10.0833 7.45703C9.69529 7.45703 9.31116 7.53446 8.95343 7.68478C8.5957 7.8351 8.27155 8.05529 7.99999 8.33246L4.66666 11.6658C4.11412 12.2183 3.80371 12.9677 3.80371 13.7491C3.80371 14.5305 4.11412 15.2799 4.66666 15.8325C5.21919 16.385 5.96859 16.6954 6.74999 16.6954C7.53139 16.6954 8.28079 16.385 8.83332 15.8325L9.24999 15.4158",
    stroke: "#0E5B48",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_143552"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenLink);
export default __webpack_public_path__ + "static/media/greenLink.035cd0b79e25d3419e98a4ceed2d0d64.svg";
export { ForwardRef as ReactComponent };